import { render } from "./user_account_payment.vue?vue&type=template&id=72671690"
import script from "./user_account_payment.vue?vue&type=script&lang=js"
export * from "./user_account_payment.vue?vue&type=script&lang=js"

import "./user_account_payment.vue?vue&type=style&index=0&id=72671690&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__